export const VerseDefaultView = ({ title, permalink, translation }) => {
	translation = translation.replace(/<[^>]+>/g, "");
	return (
		<p className="verse">
			<a href={permalink}>{title}</a> -{" "}
			{translation.replace(/<[^>]+>/g, "")}
		</p>
	);
};
